import { parseColorStrToRGBA } from '@fluid/color-utils';
import Color from 'color';
import { getMastHeadBG } from './LoginUtils';

const handleCSS = (sourceUrl, action, onSuccess, onError) => {
    if (process && process.env && process.env.NODE_ENV === 'production') {
        const cssNode = document.getElementById('dbk-login-widget-css');

        if (action === 'add') {
            if (cssNode) {
                return;
            }

            const cssUrl = sourceUrl
                .replace('/static/js', '/static/css')
                .replace('.js', '.css');

            const link = document.createElement('link');
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('type', 'text/css');
            link.setAttribute('id', 'dbk-login-widget-css');
            link.setAttribute('href', cssUrl);

            link.onload = onSuccess;
            link.onerror = onError;

            document.getElementsByTagName('head')[0].appendChild(link);
        } else {
            if (!cssNode) {
                return;
            }
            cssNode.parentNode.removeChild(cssNode);
        }
    } else if (onSuccess) {
        onSuccess();
    }
};
const addCSS = (sourceUrl, onSuccess, onError) => {
    handleCSS(sourceUrl, 'add', onSuccess, onError);
};

const removeCSS = (sourceUrl) => {
    handleCSS(sourceUrl, 'remove');
};

const isDark = (theme, backgroundColorProp) => {
    if (!theme) {
        return false;
    }

    const { attributes } = theme;
    const backgroundColorAttribute = (attributes ?? []).find((attr) => {
        return attr.key === backgroundColorProp;
    });

    if (!backgroundColorAttribute) {
        return false;
    }
    const backgroundColorStr = backgroundColorAttribute.value;
    const rgba = parseColorStrToRGBA(backgroundColorStr);
    const rgb = { r: rgba.r, g: rgba.g, b: rgba.b };
    const color = Color(rgb);

    return color.isDark();
};

const getLogoBackground = (loginConfig, theme) => {
    const { miscellaneousGroup } = loginConfig ?? {};
    const { isWebLogoBackgroundColorEnabled } = miscellaneousGroup ?? {};
    const style = {};

    if (isWebLogoBackgroundColorEnabled) {
        style.backgroundColor = getMastHeadBG(theme);
    }

    return style;
};

export { addCSS, removeCSS, isDark, getLogoBackground };
